<template>
    <div id="tg-business-detail">
        <AppBreadCrumb
            :paths="[{ title: $t('auto.telegramBreadcrumbChannelDetails') }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>

        <div class="route-page-content breadcrumb-content" v-if="channel">
            <SidebarChild
                :items="menuItems"
                :selected-item="currentTab"
                :focusActive="true"
                @selected="(i) => (currentTab = i.key)"
            />
            <div class="page-content-wrapper">
                <div class="toolbar">
                    <div class="left">
                        <IconButton :on-click="() => $router.push('/integrations/telegram-qr')">
                            <span class="material-icons"> chevron_left </span>
                        </IconButton>
                        <div class="icon-container">
                            <TelegramIcon />
                        </div>
                        <div class="name">{{ $t("auto.telegramChannelNameLabel") }} :{{ channel.name }}</div>
                    </div>
                    <div class="right">
                        <a-button type="danger" @click="deleteModal = true"
                            >{{ $t("whatsappChannel.deleteChannel") }}
                        </a-button>
                    </div>
                </div>

                <div v-if="currentTab === 'detail'">
                    <UpdateDetail v-model="channel" />
                </div>
                <div v-if="currentTab === 'visibility'">
                    <Visibility v-model="channel" />
                </div>
                <div v-if="currentTab === 'developer'">
                    <DeveloperSettings v-model="channel" />
                </div>
            </div>
        </div>

        <a-modal
            v-model="deleteModal"
            icon="exclamation-circle"
            :title="$t('auto.deleteTelegramChannelTitle')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("auto.deleteTelegramChannelConfirm") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteCurrentChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>
<script>
import Vue from "vue";
import IconButton from "../../Settings/components/IconButton.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import _ from "lodash";
import ChannelMenu from "./ChannelMenu.vue";
import Visibility from "./Visibility.vue";
import log2 from "../../../../utils/log2";
import TelegramMenuTypes from "./TelegramMenuTypes";
import UpdateDetail from "./UpdateDetail.vue";
import AppBreadCrumb from "../../../../components/common/AppBreadCrumb.vue";
import SidebarChild from "../../../../components/Sidebar/SidebarChild.vue";
import TelegramIcon from "../../Chatbot/pages/integrations/svg/TelegramIcon.vue";
import { filter } from "rxjs/operators";
import DeveloperSettings from "../components/DeveloperSettings.vue";

const log = log2("TelegramChannelDetail.vue");
export default Vue.extend({
    name: "TelegramChannelDetail",
    components: {
        TelegramIcon,
        UpdateDetail,
        Visibility,
        ChannelMenu,
        IconButton,
        AppBreadCrumb,
        SidebarChild,
        DeveloperSettings,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(TelegramMenuTypes.Items(this)).find((x) => x.key === path);
        return {
            currentTab: selected ? selected.key : "detail",
            loading: false,
            selectedChannelId: this.$route.params.id,
            deleteModal: false,
            channel: null,
            menuItems: TelegramMenuTypes.Items(this),
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "telegram-unipile"),
            siteId: (state) => _.get(state.site.site, "_id"),
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
            updateChannel: "channel/updateChannel",
        }),

        init() {
            console.log("init");

            this.channel = this.channels.find((x) => x._id === this.selectedChannelId);
            this.originalChannel = _.cloneDeep(this.channel);
            this.channel = _.cloneDeep(this.channel);
        },
        changePage(page) {
            this.currentTab = page;
        },
        deleteCurrentChannel() {
            const channel = this.channel;
            this.deleteChannel(channel._id).then(() => {
                this.$router.push("/integrations/telegram-qr");
            });
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.channel;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success("Channel updated successfully");
                        this.originalChannel = _.cloneDeep(this.channel);
                        this.$emit("ok");
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
    async mounted() {
        this.init();
    },
    watch: {
        channels: {
            handler() {
                this.init();
            },
            deep: true,
        },
        channel: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.originalChannel);
                    if (isChanged) {
                        log("channel changed=>", val);
                        this.handleSave();
                    }
                }
            },
            deep: true,
        },
        currentTab(value) {
            const selected = Object.values(this.menuItems).find((x) => x.key === value);
            if (selected) {
                this.$router.push(`/integrations/telegram-qr/${this.channel._id}/detail/${selected.key}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#tg-business-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .toolbar {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        border-bottom: 1px solid var(--color-border-default);

        .left {
            display: flex;
            align-items: center;
            gap: 5px;

            .name {
                font-size: 18px;
                font-weight: 700;
            }

            .icon-container {
                width: 30px;
                height: 30px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
                background: #e2e5ff;
                padding: 10px;
            }
        }

        .right {
            display: flex;
            justify-content: flex-end;
            gap: 5px;
        }
    }
}
</style>
